module.exports = __webpack_public_path__ + "media/images/countrysquared/vg-20ddf949a784a7f26c73b63a9c1b2959.svg";